import { FilterExperience } from './FilterExperience';
import { FilterExperienceInputContainer } from './FilterExperienceContainer';
import { useFiltersContext } from './FiltersContext';

export const Filters = () => {
  const { filterData } = useFiltersContext();
  const filters = filterData?.filters;
  if (!filters) return null;
  return (
    <>
      {filters.map((filter) => {
        return (
          <FilterExperienceInputContainer
            filter={filter}
            key={`${filter.label}-input-key`}
          >
            <FilterExperience filter={filter} />
          </FilterExperienceInputContainer>
        );
      })}
    </>
  );
};

export const StaticFilters = () => {
  const { filterData } = useFiltersContext();
  const staticFilters = filterData?.staticFilters;
  if (!staticFilters) return null;
  return (
    <>
      {staticFilters.map((filter) => {
        return (
          <FilterExperienceInputContainer
            filter={filter}
            key={`${filter.label}-input-key`}
          >
            <FilterExperience filter={filter} />
          </FilterExperienceInputContainer>
        );
      })}
    </>
  );
};
